import { Injectable } from '@angular/core';
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  constructor(private router:Router ) { }

    goTo = ( url ) => {

        const isUrl = new RegExp("(https?|ftp)://(-\.)?([^\s/?\.#-]+\.?)+(/[^\s]*)?$/");
        if (isUrl.test(url)) {
            window.location.href = url.toString();
        } else  {
            const goto = url.split("/");
            this.router.navigate(goto, { queryParamsHandling: "merge" });
        }
    }
}

